/**
 * Arkius Certification Kickstarter API
 * Arkius PBC API v5.2026.1012.0845
 *
 * The version of the OpenAPI document: v1
 * Contact: info@arkius.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SocialProvider = 0 | 1;

export const SocialProvider = {
    NUMBER_0: 0 as SocialProvider,
    NUMBER_1: 1 as SocialProvider
};

